
define('text!templates/modules/calendar/personal-data/list/personal-data-list-item.html',[],function () { return '<div class="item-section"></div>\n<div class="sub-section box"></div>\n';});

